document.addEventListener('DOMContentLoaded', function () {
	var loadMoreButton = document.getElementById('load-more');
	var productCount = document.getElementById('productCount');
	var productGridContainer = document.getElementById('ProductGridContainer');
	var productGrid = document.querySelector('.product-grid');
	var currentPage = parseInt(productGridContainer.getAttribute('data-page'), 10) || 1;
	var totalPages = parseInt(productGridContainer.getAttribute('data-total-pages'), 10);
	var totalProducts = parseInt(productGridContainer.getAttribute('data-total-products'), 10);
	function initializeLoadMore() {
		var paginationNav = document.querySelector('nav.pagination');
		if (paginationNav) {
			paginationNav.style.display = 'none';
		}

		loadMoreButton.removeEventListener('click', loadMoreProducts);
		loadMoreButton.addEventListener('click', loadMoreProducts);
		updateLoadMoreVisibility();
	}

	function updateLoadMoreVisibility() {
		productCount.innerHTML =
			'Olet katsonut ' + productGrid.querySelectorAll('.grid__item').length + ' / ' + totalProducts + ' tuotetta';
		loadMoreButton.style.display = currentPage >= totalPages ? 'none' : 'block';
	}

	function loadMoreProducts() {
		var nextPage = currentPage + 1;
		var url = new URL(window.location.href);
		url.searchParams.set('page', nextPage);

		fetch(url.toString())
			.then((response) => response.text())
			.then((data) => {
				var parser = new DOMParser();
				var htmlDocument = parser.parseFromString(data, 'text/html');
				var newProducts = htmlDocument.querySelectorAll('.product-grid .grid__item');

				if (newProducts.length > 0) {
					newProducts.forEach(function (item) {
						productGrid.appendChild(item);
					});

					currentPage = nextPage;
					productGridContainer.setAttribute('data-page', currentPage);
					updateLoadMoreVisibility();
				} else {
					loadMoreButton.style.display = 'none';
				}
			})
			.catch((error) => {
				console.error('Error loading more products:', error);
			});
	}

	function reinitializeAfterFilter() {
		currentPage = 1;
		productGridContainer.setAttribute('data-page', currentPage);
		totalPages = parseInt(productGridContainer.getAttribute('data-total-pages'), 10);
		initializeLoadMore();

		var gridItems = productGrid.querySelectorAll('.grid__item');
		gridItems.forEach((item) => {
			item.style.width = '';
			item.style.clear = '';
		});
	}

	initializeLoadMore();

	var searchForm = document.querySelector('form[action="/search"]');
	if (searchForm) {
		searchForm.addEventListener('submit', function (event) {
			setTimeout(reinitializeAfterFilter, 1000);
		});
	}

	var filterForm = document.querySelector('#FacetFiltersForm');
	if (filterForm) {
		filterForm.addEventListener('submit', function (event) {
			event.preventDefault();
			var formData = new FormData(filterForm);
			var url = new URL(window.location.href);

			formData.forEach((value, key) => {
				url.searchParams.set(key, value);
			});

			fetch(url.toString())
				.then((response) => response.text())
				.then((data) => {
					var parser = new DOMParser();
					var htmlDocument = parser.parseFromString(data, 'text/html');
					var newProductGrid = htmlDocument.querySelector('.product-grid');

					if (newProductGrid) {
						productGrid.innerHTML = newProductGrid.innerHTML;
						reinitializeAfterFilter();
					}
				})
				.catch((error) => {
					console.error('Error loading filtered products:', error);
				});
		});
	}

	window.addEventListener('popstate', initializeLoadMore);
});
